/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: ea99bacb (Fri Jun  5 23:34:18 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  Address,
  AddressFromJSON,
  AddressToJSON,
  CashAmount,
  CashAmountFromJSON,
  CashAmountToJSON,
  LicensingPaymentDetails,
  LicensingPaymentDetailsFromJSON,
  LicensingPaymentDetailsToJSON,
  PaymentMethodKey,
  PaymentStatusKey,
} from './'

/**
 *
 * @export
 * @interface LicensingPayments
 */
export interface LicensingPayments {
  /**
   *
   * @type number
   * @memberof LicensingPayments
   */
  paymentKey: number
  /**
   *
   * @type Date
   * @memberof LicensingPayments
   */
  begunAt: Date
  /**
   *
   * @type number
   * @memberof LicensingPayments
   */
  userKey: number
  /**
   *
   * @type PaymentMethodKey
   * @memberof LicensingPayments
   */
  paymentMethodKey: PaymentMethodKey
  /**
   *
   * @type CashAmount
   * @memberof LicensingPayments
   */
  amount: CashAmount
  /**
   *
   * @type CashAmount
   * @memberof LicensingPayments
   */
  tax: CashAmount
  /**
   *
   * @type string
   * @memberof LicensingPayments
   */
  taxTransactionId?: string
  /**
   *
   * @type CashAmount
   * @memberof LicensingPayments
   */
  total?: CashAmount
  /**
   *
   * @type string
   * @memberof LicensingPayments
   */
  orderId?: string
  /**
   *
   * @type PaymentStatusKey
   * @memberof LicensingPayments
   */
  paymentStatusKey: PaymentStatusKey
  /**
   *
   * @type Address
   * @memberof LicensingPayments
   */
  address?: Address
  /**
   *
   * @type string
   * @memberof LicensingPayments
   */
  desc?: string
  /**
   *
   * @type string
   * @memberof LicensingPayments
   */
  paymentProviderId?: string
  /**
   * The payment cornerstone transaction id.
   * @type string
   * @memberof LicensingPayments
   */
  transactionId?: string
  /**
   * Username of the actor who made the payment.
   * @type string
   * @memberof LicensingPayments
   */
  paidBy?: string
  /**
   * Whether the user can edit the payment or not.
   * @type boolean
   * @memberof LicensingPayments
   */
  canUserEdit?: boolean
  /**
   *
   * @type {Array<LicensingPaymentDetails>}
   * @memberof LicensingPayments
   */
  licensingPayments?: Array<LicensingPaymentDetails>
  /**
   *
   * @type LicensingPaymentDetails
   * @memberof LicensingPayments
   */
  licensingPayment: LicensingPaymentDetails
}

export function LicensingPaymentsFromJSON(json: any): LicensingPayments {
  return LicensingPaymentsFromJSONTyped(json, false)
}

export function LicensingPaymentsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): LicensingPayments {
  if (json === undefined || json === null) {
    return json
  }
  return {
    paymentKey: json['paymentKey'],
    begunAt: new Date(json['begunAt']),
    userKey: json['userKey'],
    paymentMethodKey: json['paymentMethodKey'],
    amount: CashAmountFromJSON(json['amount']),
    tax: CashAmountFromJSON(json['tax']),
    taxTransactionId: !exists(json, 'taxTransactionId')
      ? undefined
      : json['taxTransactionId'],
    total: !exists(json, 'total')
      ? undefined
      : CashAmountFromJSON(json['total']),
    orderId: !exists(json, 'orderId') ? undefined : json['orderId'],
    paymentStatusKey: json['paymentStatusKey'],
    address: !exists(json, 'address')
      ? undefined
      : AddressFromJSON(json['address']),
    desc: !exists(json, 'desc') ? undefined : json['desc'],
    paymentProviderId: !exists(json, 'paymentProviderId')
      ? undefined
      : json['paymentProviderId'],
    transactionId: !exists(json, 'transactionId')
      ? undefined
      : json['transactionId'],
    paidBy: !exists(json, 'paidBy') ? undefined : json['paidBy'],
    canUserEdit: !exists(json, 'canUserEdit') ? undefined : json['canUserEdit'],
    licensingPayments: !exists(json, 'licensingPayments')
      ? undefined
      : (json['licensingPayments'] as Array<any>).map(
          LicensingPaymentDetailsFromJSON
        ),
    licensingPayment: LicensingPaymentDetailsFromJSON(json['licensingPayment']),
  }
}

export function LicensingPaymentsToJSON(value?: LicensingPayments | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    paymentKey: value.paymentKey,
    begunAt: value.begunAt.toISOString().substr(0, 10),
    userKey: value.userKey,
    paymentMethodKey: value.paymentMethodKey,
    amount: CashAmountToJSON(value.amount),
    tax: CashAmountToJSON(value.tax),
    taxTransactionId: value.taxTransactionId,
    total: CashAmountToJSON(value.total),
    orderId: value.orderId,
    paymentStatusKey: value.paymentStatusKey,
    address: AddressToJSON(value.address),
    desc: value.desc,
    paymentProviderId: value.paymentProviderId,
    transactionId: value.transactionId,
    paidBy: value.paidBy,
    canUserEdit: value.canUserEdit,
    licensingPayments:
      value.licensingPayments === undefined
        ? undefined
        : (value.licensingPayments as Array<any>).map(
            LicensingPaymentDetailsToJSON
          ),
    licensingPayment: LicensingPaymentDetailsToJSON(value.licensingPayment),
  }
}
